/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderCardDTO
 */
export interface OrderCardDTO {
    /**
     * 
     * @type {string}
     * @memberof OrderCardDTO
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderCardDTO
     */
    personId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderCardDTO
     */
    cardSystemId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderCardDTO
     */
    overrideOrderLimit?: boolean;
}

export function OrderCardDTOFromJSON(json: any): OrderCardDTO {
    return OrderCardDTOFromJSONTyped(json, false);
}

export function OrderCardDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderCardDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'personId': !exists(json, 'personId') ? undefined : json['personId'],
        'cardSystemId': !exists(json, 'cardSystemId') ? undefined : json['cardSystemId'],
        'overrideOrderLimit': !exists(json, 'overrideOrderLimit') ? undefined : json['overrideOrderLimit'],
    };
}

export function OrderCardDTOToJSON(value?: OrderCardDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'carePrincipalId': value.carePrincipalId,
        'personId': value.personId,
        'cardSystemId': value.cardSystemId,
        'overrideOrderLimit': value.overrideOrderLimit,
    };
}

